import script from "./AttributeDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./AttributeDialog.vue?vue&type=script&setup=true&lang=ts"

import "../css/markdown-editor.less?vue&type=style&index=0&id=181b4a72&scoped=true&lang=less&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-181b4a72"]])

export default __exports__